export default __webpack_public_path__ + "static/img13h-7fe96f26de1c2c46a65ce688de2995cd.jpg";